import { action, computed, observable } from 'mobx'
import { SortAttributesList } from '@constants'
import { filter, forEach } from 'lodash'

export interface IAttribute {
  name: string
  attributeName: string
  value: string
  isSelected: boolean
  disabled: boolean
}

export class AttributeSortStore {
  @observable attributesList: Array<IAttribute> = SortAttributesList

  @observable anchorEl = null
  @observable openSortModal = false

  @action setSelectedSortAttribute = (value: string, checked: boolean) => {
    this.handleClose()
    forEach(this.attributesList, attribute => {
      if (attribute.value === value) {
        attribute.isSelected = checked
      } else {
        attribute.isSelected = !checked
      }
    })
  }

  @action clearSelection = () => {
    this.handleClose()
    forEach(this.attributesList, attribute => {
      attribute.isSelected = false
    })
  }

  @computed
  get selectedSortType() {
    return filter(this.attributesList, attribute => attribute.isSelected)?.[0]?.value
  }

  @computed
  get selectedSortTypeName() {
    return filter(this.attributesList, attribute => attribute.isSelected)?.[0]?.name
  }

  @action
  handleClose = () => {
    this.anchorEl = null
    this.openSortModal = false
  }
  @action
  handleSortClick = event => {
    this.anchorEl = event.currentTarget
    this.openSortModal = true
  }
}

export const attributeSortStore = new AttributeSortStore()
